'use client';

import React, { ReactNode } from 'react';
import { BLOCKS, MARKS } from '@contentful/rich-text-types';
import { RichText } from '../RichText/RichText';
import { useStoredHeaderLocation } from '@/lib/hooks/useStoredHeaderLocation';
import { tokenizeDynamicText } from '@/lib/tokens/dynamicTokenRenderer';
import { useLayoutContext } from '@/components/Layout/LayoutProvider';
import { TokenizedRichTextProps } from './types';

export default function TokenizedRichText({
  content,
  className,
  inCityClassName = 'text-brand-accent',
  variant,
}: TokenizedRichTextProps) {
  const { brandCode } = useLayoutContext();
  const selectedLocation = useStoredHeaderLocation(brandCode);

  const options =
    variant === 'textOnlyHeroTitle'
      ? {
          renderMark: {
            [MARKS.BOLD]: (text: ReactNode) => (
              <strong className='text-hero-text-highlight'>{text}</strong>
            ),
          },
          renderNode: {
            [BLOCKS.PARAGRAPH]: (_node: unknown, children: ReactNode) => (
              <strong>{children}</strong>
            ),
          },
          renderText: (text: string) =>
            tokenizeDynamicText(
              text,
              {
                inCity: selectedLocation?.locality ?? null,
              },
              {
                inCity: (value) =>
                  value ? (
                    <>
                      {' in '}
                      <span className={inCityClassName}>{`${value}?`}</span>
                    </>
                  ) : (
                    '?'
                  ),
              },
            ),
        }
      : {
          renderText: (text: string) =>
            tokenizeDynamicText(
              text,
              {
                inCity: selectedLocation?.locality ?? null,
              },
              {
                inCity: (value) =>
                  value ? (
                    <>
                      {' in '}
                      <span className={inCityClassName}>{`${value}?`}</span>
                    </>
                  ) : (
                    '?'
                  ),
              },
            ),
        };

  return (
    <RichText
      data={{
        content,
        className,
        options,
      }}
    />
  );
}
